import { render } from "./Card.vue?vue&type=template&id=3d56bf03"
const script = {}
script.render = render

export default script